// import React, { useState } from 'react';
// import {
//   Box,
//   Paper,
//   TextField,
//   Button,
//   Typography,
//   Alert,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Stepper,
//   Step,
//   StepLabel,
// } from '@mui/material';
// import {
//   Person,
//   Email,
//   Lock,
//   Business,
//   Visibility,
//   VisibilityOff,
//   Security,
//   CheckCircle,
// } from '@mui/icons-material';
// import { useNavigate, Link as RouterLink } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';

// const steps = ['Account Details', 'Company Info', 'Complete'];

// export default function Signup() {
//   const navigate = useNavigate();
//   const { signup } = useAuth();
//   const [activeStep, setActiveStep] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     password: '',
//     confirmPassword: '',
//     company: '',
//   });

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//     setError('');
//   };

//   const validateStep1 = () => {
//     if (!formData.name.trim()) {
//       setError('Full name is required');
//       return false;
//     }
//     if (!formData.email.trim()) {
//       setError('Email is required');
//       return false;
//     }
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       setError('Enter a valid email address');
//       return false;
//     }
//     if (!formData.password) {
//       setError('Password is required');
//       return false;
//     }
//     if (formData.password.length < 6) {
//       setError('Password must be at least 6 characters');
//       return false;
//     }
//     if (formData.password !== formData.confirmPassword) {
//       setError('Passwords do not match');
//       return false;
//     }
//     return true;
//   };

//   const validateStep2 = () => {
//     if (!formData.company.trim()) {
//       setError('Company name is required');
//       return false;
//     }
//     return true;
//   };

//   const handleNext = () => {
//     if (activeStep === 0 && validateStep1()) {
//       setActiveStep(1);
//     } else if (activeStep === 1 && validateStep2()) {
//       handleSubmit();
//     }
//   };

//   const handleBack = () => {
//     setActiveStep(activeStep - 1);
//     setError('');
//   };

//   const handleSubmit = async () => {
//     setLoading(true);
//     setError('');

//     try {
//       await signup(formData.name, formData.email, formData.password, formData.company);
//       navigate('/');
//     } catch (err: any) {
//       setError(err.message);
//       setActiveStep(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         bgcolor: '#f8fafc',
//         p: 2,
//       }}
//     >
//       <Paper
//         elevation={0}
//         sx={{
//           maxWidth: 500,
//           width: '100%',
//           p: 4,
//           borderRadius: 3,
//           boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
//         }}
//       >
//         {/* Logo */}
//         <Box sx={{ textAlign: 'center', mb: 4 }}>
//           <Box
//             sx={{
//               width: 48,
//               height: 48,
//               bgcolor: 'primary.main',
//               borderRadius: 2,
//               display: 'inline-flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mb: 2,
//             }}
//           >
//             <Security sx={{ color: 'white', fontSize: 28 }} />
//           </Box>
//           <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
//             Create Account
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Join TPRM Platform to manage vendor risks
//           </Typography>
//         </Box>

//         {/* Stepper */}
//         <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
//           {steps.map((label) => (
//             <Step key={label}>
//               <StepLabel>{label}</StepLabel>
//             </Step>
//           ))}
//         </Stepper>

//         {/* Error Alert */}
//         {error && (
//           <Alert severity="error" sx={{ mb: 3 }}>
//             {error}
//           </Alert>
//         )}

//         {/* Step 1: Account Details */}
//         {activeStep === 0 && (
//           <>
//             <TextField
//               fullWidth
//               label="Full Name"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               required
//               sx={{ mb: 2 }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Person color="action" />
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <TextField
//               fullWidth
//               label="Email Address"
//               name="email"
//               type="email"
//               value={formData.email}
//               onChange={handleChange}
//               required
//               sx={{ mb: 2 }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Email color="action" />
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <TextField
//               fullWidth
//               label="Password"
//               name="password"
//               type={showPassword ? 'text' : 'password'}
//               value={formData.password}
//               onChange={handleChange}
//               required
//               sx={{ mb: 2 }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Lock color="action" />
//                   </InputAdornment>
//                 ),
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//               helperText="Minimum 6 characters"
//             />

//             <TextField
//               fullWidth
//               label="Confirm Password"
//               name="confirmPassword"
//               type={showConfirmPassword ? 'text' : 'password'}
//               value={formData.confirmPassword}
//               onChange={handleChange}
//               required
//               sx={{ mb: 2 }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Lock color="action" />
//                   </InputAdornment>
//                 ),
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//           </>
//         )}

//         {/* Step 2: Company Info */}
//         {activeStep === 1 && (
//           <>
//             <TextField
//               fullWidth
//               label="Company Name"
//               name="company"
//               value={formData.company}
//               onChange={handleChange}
//               required
//               sx={{ mb: 2 }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Business color="action" />
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <Box
//               sx={{
//                 bgcolor: '#f0fdf4',
//                 p: 2,
//                 borderRadius: 2,
//                 mt: 2,
//               }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                 <CheckCircle color="success" fontSize="small" />
//                 <Typography variant="subtitle2" fontWeight={600}>
//                   What happens next?
//                 </Typography>
//               </Box>
//               <Typography variant="body2" color="text.secondary">
//                 After signup, you'll be able to:
//               </Typography>
//               <Box component="ul" sx={{ pl: 2, mt: 1, mb: 0 }}>
//                 <Typography component="li" variant="body2" color="text.secondary">
//                   Run security scans on vendors
//                 </Typography>
//                 <Typography component="li" variant="body2" color="text.secondary">
//                   Track risk scores over time
//                 </Typography>
//                 <Typography component="li" variant="body2" color="text.secondary">
//                   Generate compliance reports
//                 </Typography>
//               </Box>
//             </Box>
//           </>
//         )}

//         {/* Navigation Buttons */}
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
//           {activeStep > 0 && (
//             <Button onClick={handleBack} disabled={loading}>
//               Back
//             </Button>
//           )}
//           <Button
//             variant="contained"
//             onClick={handleNext}
//             disabled={loading}
//             sx={{ ml: activeStep === 0 ? 'auto' : 0 }}
//           >
//             {loading ? <CircularProgress size={24} /> : activeStep === steps.length - 1 ? 'Create Account' : 'Next'}
//           </Button>
//         </Box>

//         <Typography variant="body2" textAlign="center" color="text.secondary" sx={{ mt: 3 }}>
//           Already have an account?{' '}
//           <Link component={RouterLink} to="/login" underline="hover">
//             Sign in
//           </Link>
//         </Typography>
//       </Paper>
//     </Box>
//   );
// }
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import {
  ArrowBackRounded, BusinessOutlined, CheckRounded, EmailOutlined, GroupsOutlined, HubOutlined, LanguageOutlined,
  LockOutlined, PersonOutline, RefreshRounded,
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import AuthLayout, { AuthAlert, AuthField, AuthSelect, AuthSteps, PasswordToggle, Spinner } from './auth/AuthLayout';

const steps = ['Your details', 'Verify email', 'Done'];

// Must match backend/services/signup_profile.py exactly (the server only accepts these values).
const COMPANY_SIZES = ['1-50', '51-200', '201-1000', '1001-5000', '5000+'] as const;
const VENDORS_MANAGED = ['1-10', '11-50', '51-200', '201-500', '500+'] as const;

// ─── FALLBACK BANNED EMAIL DOMAINS ──────────────────────────────────────────
const FALLBACK_TEMP_DOMAINS = [
  '10minutemail.com', 'temp-mail.org', 'guerrillamail.com',
  'mailinator.com', 'trashmail.com', 'yopmail.com',
  'tempmail.com', 'throwaway.email', 'mailnator.com',
  '33mail.com', '20minutemail.com', 'fakemail.net',
  'guerrillamail.net', 'guerrillamail.biz', 'maildrop.cc',
  'dispostable.com', 'spamgourmet.com', 'junkmail.com',
  'mytemp.email', 'temporary-email.com', 'emailfake.com',
  'fakeinbox.com', 'getnada.com', 'mailnesia.com',
  'spambox.us', 'throwawaymail.com', 'trash2000.com',
  'tempmail.net', 'spamdecoy.net', 'mailmetrash.com',
  'shortmail.com', 'mailsac.com', 'guerillamail.com',
  'emailondeck.com', 'cunairt.com',
];

const FALLBACK_FREE_DOMAINS = [
  'gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com',
  'aol.com', 'icloud.com', 'mail.com', 'protonmail.com',
  'zoho.com', 'yandex.com', 'gmx.com', 'tutanota.com',
  'fastmail.com', 'hushmail.com', 'safe-mail.net'
];

const STRENGTH = [
  { label: 'Too short', color: '#DC2626' },
  { label: 'Weak', color: '#DC2626' },
  { label: 'Fair', color: '#D97706' },
  { label: 'Good', color: '#2563EB' },
  { label: 'Strong', color: '#15803D' },
];

function passwordStrength(pw: string): number {
  if (pw.length < 6) return 0;
  let s = 1;
  if (pw.length >= 10) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw) && /[^A-Za-z0-9]/.test(pw)) s++;
  return Math.min(s, 4);
}

export default function Signup() {
  const navigate = useNavigate();
  const { signup } = useAuth();

  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [error, setError] = useState('');
  const [otpError, setOtpError] = useState('');
  const [otpSuccess, setOtpSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  // Consent (Terms of Service / Privacy Policy + optional marketing opt-in), collected once OTP is verified
  // and before the account is actually created.
  const [showConsentModal, setShowConsentModal] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [marketingConsent, setMarketingConsent] = useState(false);
  // Arriving from the vendor portal ("Get your full report"): the link carries a signed claim plus the person's
  // name, email, company and domain, so the form starts filled in and the new workspace starts with their rating.
  const [portalPrefill] = useState(() => {
    const q = new URLSearchParams(window.location.search);
    return {
      claim: q.get('portal_claim') || '', name: q.get('name') || '', email: q.get('email') || '',
      company: q.get('company') || '', domain: q.get('domain') || '',
    };
  });
  const [formData, setFormData] = useState({
    name: portalPrefill.name,
    email: portalPrefill.email,
    password: '',
    confirmPassword: '',
    company: portalPrefill.company,
    companyDomain: portalPrefill.domain,
  });
  // The company domain follows the email's domain until the user edits it themselves.
  const [domainTouched, setDomainTouched] = useState(!!portalPrefill.domain);
  const [emailHelperText, setEmailHelperText] = useState('');

  // ─── Blocklist State ───────────────────────────────────────────────────────
  const [disposableDomains, setDisposableDomains] = useState<string[]>(FALLBACK_TEMP_DOMAINS);
  const [freeDomains] = useState<string[]>(FALLBACK_FREE_DOMAINS);
  const [companySize, setCompanySize] = useState('');
  const [vendorsManaged, setVendorsManaged] = useState('');

  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  // ─── Fetch Blocklist from Backend ────────────────────────────────────────
  useEffect(() => {
    const fetchBlocklist = async () => {
      try {
        const response = await api.get('/v1/email/blocklist');
        if (response.data?.domains && response.data.domains.length > 0) {
          setDisposableDomains(response.data.domains);
          console.log(`✅ Loaded ${response.data.domains.length} disposable domains from backend`);
        }
      } catch (error) {
        console.warn('⚠️ Could not fetch blocklist from backend, using fallback list');
      }
    };
    fetchBlocklist();
  }, []);

  // ─── Timer for OTP Resend ──────────────────────────────────────────────────
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            setCanResend(true);
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  // ─── Auto-focus OTP inputs ─────────────────────────────────────────────────
  useEffect(() => {
    if (activeStep === 1 && otpSent) {
      inputRefs.current[0]?.focus();
    }
  }, [activeStep, otpSent]);

  // ─── Email validation on change ──────────────────────────────────────────
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const email = e.target.value;
    const emailDomain = email.split('@')[1]?.toLowerCase().trim() || '';
    setFormData({ ...formData, email, companyDomain: domainTouched ? formData.companyDomain : (emailDomain.includes('.') ? emailDomain : '') });
    setError('');
    
    if (!email) {
      setEmailHelperText('');
      return;
    }

    const domain = email.split('@')[1]?.toLowerCase();
    
    if (domain && freeDomains.includes(domain)) {
      setEmailHelperText('⚠️ Please use your business email. Free email services are not allowed for security reasons.');
    } 
    else if (domain && disposableDomains.includes(domain)) {
      setEmailHelperText('⚠️ Temporary/disposable email addresses are not allowed. Please use your business email.');
    }
    else if (domain && !domain.includes('.')) {
      setEmailHelperText('Please enter a valid domain (e.g., company.com)');
    }
    else if (email.includes('@') && domain) {
      setEmailHelperText('✅ Business email format looks valid');
    }
    else {
      setEmailHelperText('');
    }
  };

  // ─── Handlers ──────────────────────────────────────────────────────────────
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === 'email') {
      handleEmailChange(e);
    } else {
      if (e.target.name === 'companyDomain') setDomainTouched(true);
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
      setError('');
    }
  };

  const handleOtpChange = (index: number, value: string) => {
    if (value.length > 1) return;
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setOtpError('');

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    if (e.key === 'Enter') {
      handleVerifyOtp();
    }
  };

  // ─── Validate Steps ────────────────────────────────────────────────────────
  const validateStep1 = () => {
    if (!formData.name.trim()) {
      setError('Full name is required');
      return false;
    }
    if (!formData.email.trim()) {
      setError('Email is required');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError('Enter a valid email address (e.g., name@company.com)');
      return false;
    }
    
    const domain = formData.email.split('@')[1]?.toLowerCase();
    
    if (domain && freeDomains.includes(domain)) {
      setError('Please use your business email. Free email services like Gmail, Yahoo, and Outlook are not allowed for security reasons.');
      return false;
    }
    
    if (domain && disposableDomains.includes(domain)) {
      setError('Temporary/disposable email addresses are not allowed. Please use your business email.');
      return false;
    }
    
    if (!formData.password) {
      setError('Password is required');
      return false;
    }
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return false;
    }
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return false;
    }
    if (!formData.company.trim()) {
      setError('Company name is required');
      return false;
    }
    if (!companySize) {
      setError('Choose your company size');
      return false;
    }
    if (!vendorsManaged) {
      setError('Choose how many vendors you manage');
      return false;
    }
    const companyDomain = formData.companyDomain.trim().toLowerCase().replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/\/.*$/, '');
    if (companyDomain && !/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/.test(companyDomain)) {
      setError('Enter a valid company domain, e.g. acme.com');
      return false;
    }
    return true;
  };

  // ─── OTP Functions ─────────────────────────────────────────────────────────
  const handleSendOtp = async () => {
    if (!validateStep1()) return;

    setOtpLoading(true);
    setOtpError('');
    setError('');

    try {
      console.log('📤 Sending OTP to:', formData.email);
      const response = await api.post('/v1/auth/send-otp', {
        email: formData.email,
        name: formData.name,
        company: formData.company,
      });
      console.log('✅ OTP sent:', response.data);

      setOtpSent(true);
      setActiveStep(1);
      setTimer(60);
      setCanResend(false);
      setOtpSuccess(true);

    } catch (err: any) {
      console.error('❌ Send OTP error:', err);
      console.error('   Response:', err.response?.data);
      
      // ─── HANDLE 422 VALIDATION ERRORS ────────────────────────────────────
      if (err.response?.status === 422) {
        const detail = err.response?.data?.detail;
        let errorMessage = 'Validation error';
        
        // Check if detail is an array (FastAPI validation errors)
        if (Array.isArray(detail)) {
          const messages = detail.map((error: any) => {
            const field = error.loc?.join('.') || 'unknown';
            const msg = error.msg || error.message || 'Invalid value';
            return `${field}: ${msg}`;
          });
          errorMessage = messages.join('; ');
        } else if (typeof detail === 'string') {
          errorMessage = detail;
        } else if (detail && typeof detail === 'object') {
          try {
            errorMessage = JSON.stringify(detail);
          } catch {
            errorMessage = 'Validation failed. Please check your input.';
          }
        } else {
          errorMessage = 'Validation failed. Please check your input and try again.';
        }
        
        setError(errorMessage);
        setActiveStep(0);
        setOtpLoading(false);
        return;
      }
      
      // ─── HANDLE OTHER ERRORS ────────────────────────────────────────────
      let errorMessage = 'Failed to send OTP. Please try again.';
      
      if (err.response?.data?.detail) {
        const detail = err.response.data.detail;
        if (typeof detail === 'string') {
          errorMessage = detail;
        } else if (Array.isArray(detail)) {
          errorMessage = detail.map((e: any) => e.msg || e.message).join('; ');
        } else if (typeof detail === 'object') {
          try {
            errorMessage = JSON.stringify(detail);
          } catch {
            errorMessage = 'Validation error';
          }
        }
      } else if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      }
      
      // Check for specific error types
      if (errorMessage.includes('free email') || errorMessage.includes('business email')) {
        setError('Please use your business email. Free email services like Gmail, Yahoo, and Outlook are not allowed for security reasons.');
      } else if (errorMessage.includes('temporary') || errorMessage.includes('disposable')) {
        setError('Temporary or disposable email addresses are not allowed. Please use a valid business email.');
      } else if (errorMessage.includes('domain') || errorMessage.includes('MX')) {
        setError('We couldn\'t verify your business domain. Please ensure you\'re using a valid company email address.');
      } else if (errorMessage.includes('organization') && errorMessage.includes('already registered')) {
        setError(errorMessage);
      } else {
        setError(errorMessage);
      }
      
      setActiveStep(0);
      setOtpLoading(false);
    } finally {
      // Ensure loading is reset in all cases
      setOtpLoading(false);
    }
  };

  // ─── Verify OTP and Signup ────────────────────────────────────────────────
  const handleVerifyOtp = async () => {
  const otpString = otp.join('');
  if (otpString.length !== 6) {
    setOtpError('Please enter all 6 digits');
    return;
  }

  setOtpLoading(true);
  setOtpError('');
  setError('');

  try {
    const response = await api.post('/v1/auth/verify-otp', {
      email: formData.email,
      otp: otpString,
    });

    if (response.data.verified) {
      setOtpVerified(true);
      setOtpSuccess(true);
      setOtpLoading(false);
      // Account creation itself waits for the consent modal's "Confirm" click.
      setShowConsentModal(true);
      return;
    }
  } catch (err: any) {
    let errorMessage = 'Invalid OTP. Please try again.';
    const detail = err.response?.data?.detail;
    if (typeof detail === 'string') {
      errorMessage = detail;
    } else if (Array.isArray(detail)) {
      errorMessage = detail.map((e: any) => e.msg || e.message).join('; ');
    }
    setOtpError(errorMessage);
    setOtp(['', '', '', '', '', '']);
    inputRefs.current[0]?.focus();
  } finally {
    setOtpLoading(false);
  }
};

  // ─── Confirm consent and actually create the account ─────────────────────
  const handleConfirmConsent = async () => {
    if (!agreeToTerms) return;

    setShowConsentModal(false);
    setActiveStep(2);
    setLoading(true);

    try {
      await signup(formData.name, formData.email, formData.password, formData.company, formData.companyDomain.trim() || undefined,
        portalPrefill.claim || undefined, agreeToTerms, marketingConsent, companySize, vendorsManaged);
      setTimeout(() => navigate('/dashboard'), 1500);
    } catch (signupErr: any) {
      console.error('❌ Signup error:', signupErr);
      let errorMessage = 'Signup failed. Please try again.';

      const detail = signupErr.response?.data?.detail;
      if (typeof detail === 'string') {
        errorMessage = detail;
      } else if (Array.isArray(detail)) {
        errorMessage = detail.map((e: any) => e.msg || e.message || JSON.stringify(e)).join('; ');
      } else if (detail && typeof detail === 'object') {
        errorMessage = JSON.stringify(detail);
      }

      setError(errorMessage);
      setActiveStep(0);
      setLoading(false);
      setOtpLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!canResend) return;

    setOtpLoading(true);
    setOtpError('');

    try {
      console.log('📤 Resending OTP to:', formData.email);
      await api.post('/v1/auth/resend-otp', {
        email: formData.email,
        name: formData.name,
        company: formData.company,
      });

      setTimer(60);
      setCanResend(false);
      setOtp(['', '', '', '', '', '']);
      setOtpSuccess(true);
      inputRefs.current[0]?.focus();

    } catch (err: any) {
      console.error('❌ Resend OTP error:', err);
      
      let errorMessage = 'Failed to resend OTP. Please try again.';
      if (err.response?.data?.detail) {
        errorMessage = err.response.data.detail;
      }
      
      if (errorMessage.includes('organization') && errorMessage.includes('already registered')) {
        setError(errorMessage);
        setActiveStep(0);
      } else {
        setOtpError(errorMessage);
      }
    } finally {
      setOtpLoading(false);
    }
  };

  // ─── Handle Back ───────────────────────────────────────────────────────────
  const handleBack = () => {
    if (activeStep === 1) {
      setOtpSent(false);
      setOtpVerified(false);
      setOtp(['', '', '', '', '', '']);
      setOtpError('');
      setActiveStep(0);
    }
  };

  const handleOtpPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const digits = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (!digits) return;
    e.preventDefault();
    setOtp(['', '', '', '', '', ''].map((_, i) => digits[i] || ''));
    setOtpError('');
    inputRefs.current[Math.min(digits.length, 5)]?.focus();
  };

  const emailTone: 'muted' | 'ok' | 'warn' =
    emailHelperText.startsWith('✅') ? 'ok' : emailHelperText.startsWith('⚠️') ? 'warn' : 'muted';
  const emailHint = emailHelperText
    ? emailHelperText.replace(/^(✅|⚠️)\s*/, '')
    : 'Use your company email. Personal addresses (Gmail, Outlook, Yahoo) are not accepted.';
  const strength = passwordStrength(formData.password);
  const confirmMismatch = !!formData.confirmPassword && formData.confirmPassword !== formData.password;

  const titles = ['Create your account', 'Check your email', loading ? 'Setting up your workspace' : "You're all set"];
  const subtitles = [
    '30-day free trial. No card needed.',
    <>We sent a 6-digit code to <b>{formData.email}</b>.</>,
    loading ? 'This only takes a moment.' : 'Your workspace is ready.',
  ];

  return (
    <AuthLayout variant="signup" width={activeStep === 0 ? 520 : 440}>
      <h1 className="fwa-title">{titles[activeStep]}</h1>
      <p className="fwa-sub">{subtitles[activeStep]}</p>

      <AuthSteps steps={steps} active={activeStep} />

      {error && <AuthAlert>{error}</AuthAlert>}

      {activeStep === 0 && (
        <form noValidate onSubmit={(e) => { e.preventDefault(); handleSendOtp(); }}>
          <div className="fwa-grid">
            <AuthField id="su-name" label="Full name" icon={<PersonOutline />} name="name" autoComplete="name"
              placeholder="Jane Cooper" value={formData.name} onChange={handleChange} required />
            <AuthField id="su-company" label="Company name" icon={<BusinessOutlined />} name="company" autoComplete="organization"
              placeholder="Acme Corp" value={formData.company} onChange={handleChange} required />
          </div>

          <AuthField id="su-email" label="Work email" icon={<EmailOutlined />} name="email" type="email" autoComplete="email"
            placeholder="you@company.com" value={formData.email} onChange={handleChange} required
            hint={emailHint} hintTone={emailTone} />

          <AuthField id="su-domain" label="Company website" icon={<LanguageOutlined />} name="companyDomain"
            placeholder="acme.com" value={formData.companyDomain} onChange={handleChange}
            labelRight={<span style={{ fontSize: 12, color: '#94A3B8' }}>Optional</span>}
            hint="We assess it so you can see your own security posture under My Organization. You can change it later." />

          <div className="fwa-grid">
            <AuthSelect id="su-size" label="Company size" icon={<GroupsOutlined />} placeholder="Employees"
              value={companySize} onChange={v => { setCompanySize(v); setError(''); }} options={COMPANY_SIZES} />
            <AuthSelect id="su-vendors" label="Vendors you manage" icon={<HubOutlined />} placeholder="Number of vendors"
              value={vendorsManaged} onChange={v => { setVendorsManaged(v); setError(''); }} options={VENDORS_MANAGED} />
          </div>

          <div className="fwa-grid">
            <AuthField id="su-password" label="Password" icon={<LockOutlined />} name="password" autoComplete="new-password"
              type={showPassword ? 'text' : 'password'} placeholder="At least 6 characters"
              value={formData.password} onChange={handleChange} required
              trailing={<PasswordToggle shown={showPassword} onToggle={() => setShowPassword(!showPassword)} />}
              after={formData.password ? (
                <>
                  <div className="fwa-meter">
                    {[1, 2, 3, 4].map(n => <i key={n} style={n <= strength ? { background: STRENGTH[strength].color } : undefined} />)}
                  </div>
                  <div className="fwa-hint" style={{ color: STRENGTH[strength].color }}>{STRENGTH[strength].label}</div>
                </>
              ) : undefined} />
            <AuthField id="su-confirm" label="Confirm password" icon={<LockOutlined />} name="confirmPassword" autoComplete="new-password"
              type={showConfirmPassword ? 'text' : 'password'} placeholder="Repeat your password"
              value={formData.confirmPassword} onChange={handleChange} required
              trailing={<PasswordToggle shown={showConfirmPassword} onToggle={() => setShowConfirmPassword(!showConfirmPassword)} />}
              hint={confirmMismatch ? "Passwords don't match yet" : formData.confirmPassword ? 'Passwords match' : undefined}
              hintTone={confirmMismatch ? 'warn' : 'ok'} />
          </div>

          <div style={{ height: 6 }} />
          <button className="fwa-btn" type="submit" disabled={otpLoading}>
            {otpLoading ? <Spinner /> : 'Continue'}
          </button>
          <p className="fwa-hint" style={{ textAlign: 'center', marginTop: 12 }}>
            We'll email you a code to confirm it's really you.
          </p>
        </form>
      )}

      {activeStep === 1 && (
        <div>
          {otpSuccess && <AuthAlert tone="success">Code sent. It can take a minute to arrive, so check spam too.</AuthAlert>}

          <div className="fwa-otp-row">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => { inputRefs.current[index] = el; }}
                className={`fwa-otp${digit ? ' is-filled' : ''}`}
                value={digit}
                inputMode="numeric"
                autoComplete={index === 0 ? 'one-time-code' : 'off'}
                maxLength={1}
                aria-label={`Digit ${index + 1}`}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleOtpKeyDown(index, e)}
                onPaste={handleOtpPaste}
              />
            ))}
          </div>

          {otpError && <AuthAlert>{otpError}</AuthAlert>}

          <button className="fwa-btn" onClick={handleVerifyOtp} disabled={otpLoading || otp.join('').length !== 6}>
            {otpLoading ? <Spinner /> : 'Verify and create account'}
          </button>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, fontSize: 14, color: '#64748B' }}>
            <span>{timer > 0 ? `Resend available in ${timer}s` : "Didn't get the code?"}</span>
            <button type="button" className="fwa-link" onClick={handleResendOtp} disabled={!canResend || otpLoading}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
              <RefreshRounded style={{ fontSize: 17 }} /> Resend code
            </button>
          </div>

          <button type="button" className="fwa-btn-ghost" onClick={handleBack}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginTop: 18 }}>
            <ArrowBackRounded style={{ fontSize: 17 }} /> Use a different email
          </button>
        </div>
      )}

      {activeStep === 2 && (
        <div className="fwa-done">
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '18px 0' }}><Spinner dark /></div>
          ) : (
            <>
              <div className="fwa-done-ic"><CheckRounded /></div>
              <button className="fwa-btn" onClick={() => navigate('/dashboard')}>Go to dashboard</button>
            </>
          )}
        </div>
      )}

      {activeStep < 2 && (
        <p className="fwa-foot">
          Already have an account? <RouterLink className="fwa-link" to="/login">Sign in</RouterLink>
        </p>
      )}

      {/* Consent: shown once, right after OTP verification, before the account is created. Not dismissable. */}
      {showConsentModal && (
        <div className="fwa-overlay" role="dialog" aria-modal="true" aria-labelledby="fwa-consent-title">
          <div className="fwa-modal">
            <h3 id="fwa-consent-title">One last step</h3>
            <p>Your email is verified. Please confirm the following to create your workspace.</p>

            <label className="fwa-check">
              <input type="checkbox" checked={agreeToTerms} onChange={(e) => setAgreeToTerms(e.target.checked)} />
              <span>
                I have read and agree to the{' '}
                <a href="/terms" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>Terms of Service</a>
                {' '}and{' '}
                <a href="/privacy" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>Privacy Policy</a>.
              </span>
            </label>

            <label className="fwa-check">
              <input type="checkbox" checked={marketingConsent} onChange={(e) => setMarketingConsent(e.target.checked)} />
              <span>Send me product news, feature updates and offers from FluxWatch. <span style={{ color: '#94A3B8' }}>(Optional)</span></span>
            </label>

            <div style={{ height: 10 }} />
            <button className="fwa-btn" disabled={!agreeToTerms} onClick={handleConfirmConsent}>Create my account</button>
          </div>
        </div>
      )}
    </AuthLayout>
  );
}
